import React from "react";
import {NavLink} from "react-router-dom";
import {BASE_PATH} from "../../../../../wpconfig";

const RBasic = (parent) => {
	// console.log(parent)
	const record = parent.record;
	console.log(record)
	// const record = this.props.record;
	//
	return (
		<div>
			<div className="document-list-item">
				<div className="item-subject big">{record.resource_title}
					{rmVars.isEditor &&
					<a href={rmVars.homeUrl + "?page=resource&record_id=" + record.resource_id}
					   target="_blank"
					   className="ml-2"><span className="editor-edit"></span></a>
					}
				</div>
				<div className="item-info mt-2">
					<div className="info-cell">
						{record.issn ? (
							<>
								<strong>ISSN</strong> {record.issn}
							</>
						) : record.eissn ? (
							<>
								<strong>E-ISSN</strong> {record.eissn}
							</>
						) : (
							<>
								<strong>ISSN</strong>
							</>
						)}
					</div>
					<div className="info-cell"><strong>Publisher</strong> {record.publisher}</div>
					<div className="info-cell">
						{record.publish_year ? record.publish_year : ''}
						{record.volume ? (record.publish_year ? ', ' + record.volume : record.volume) : ''}
						{record.issue ? (record.volume ? '(' + record.issue + ')' : ', no.' + record.issue) : ''}
						{record.start_page && record.end_page ? ', pp. ' : (record.start_page || record.end_page ? ', pp.' : '')}
						{record.start_page ? record.start_page + '-' : ''}
						{record.end_page ? (record.start_page ? record.end_page : '-' + record.end_page) : ''}
					</div>
				</div>
				<div className="item-options mt-3">
					<div className="options-cell">
						<div className="badge-group">
							<div className="badge-group-inner">
								{record.registered_db && record.registered_db.map((item, num) => {
									let className = 'badge bg-lightpurple';
									if (!item)
										return;
									// item = item.toUpperCase()
									if (item.includes('KCI'))
										className = 'badge bg-lightgreen';
									else if (item.includes('Scopus'))
										className = 'badge bg-lightorange';
									else if (item.includes('Nature Index'))
										className = 'badge bg-skyblue';
									return (
										<div key={num} className={className}>{item}</div>
									)
								})}
							</div>
						</div>
					</div>
					<div className="options-cell ml-3 mr-3">
						<div className="info-cell">
							{record.cited_count_info && <strong>인용횟수</strong>}
							{record.cited_count_info && record.cited_count_info.map((item, num) => {
								return (
									<span key={num} className="mr-2"><span className="text-success">{item.db_title}</span> {item.cite_count}</span>
								)
							})}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RBasic;
